import React, { PureComponent } from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'
import { lighten } from 'polished'

import { formatItemValue } from './formatter'

import { Text } from '../../Atoms/Typography'
import Icon from '../../Atoms/Icon'
import TranslatedText from '../../Atoms/TranslatedText'
import Touchable from '../../Atoms/Touchable'
import ValueChangeText from '../../Molecules/ValueChangeText'

import theme from '../../../styles/theme'

import { translate } from '../../../services/translate'

const Card = styled(View)`
  flex: 1;
`

const CardContent = styled(View)`
  border-top-left-radius: ${theme.gutterUnit}px;
  border-top-right-radius: ${theme.gutterUnit}px;
  flex: 6;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: ${2 * theme.gutterUnit}px;
  border-color: ${props => props.borderColour};
  border-width: 2px;
`

const CardMetrics = styled(View)`
  border-bottom-left-radius: ${theme.gutterUnit}px;
  border-bottom-right-radius: ${theme.gutterUnit}px;
  flex: 4;
  flex-direction: column;
  padding: ${2 * theme.gutterUnit}px;
  align-items: center;
  justify-content: center;
  borderLeftColor: ${props => props.borderColour};
  borderLeftWidth: 2px;
  borderRightColor: ${props => props.borderColour};
  borderRightWidth: 2px;
  borderBottomColor: ${props => props.borderColour};
  borderBottomWidth: 2px;
`

const ValueRow = styled(View)`
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

const HelpIcon = styled(View)`
  align-self: flex-end;
  height: 30px;
  z-index: 10;
  margin: -10px;
`

const IconContainer = styled(View)`
  margin-top: -30px;
`

const configuration = {
  NPAT_GROWTH: {
    iconName: 'growth',
    iconHeight: 70,
    iconWidth: 70,
    changeUnit: '%',
    isCost: false
  },
  NIM: {
    iconName: 'clamp',
    iconHeight: 70,
    iconWidth: 70,
    changeUnit: 'bps',
    isCost: false
  },
  COF: {
    iconName: 'cash',
    iconHeight: 70,
    iconWidth: 70,
    changeUnit: 'bps',
    isCost: true
  },
  CTIR: {
    iconName: 'cost_to_income_new',
    iconHeight: 70,
    iconWidth: 70,
    changeUnit: '%',
    isCost: true
  },
  LIE: {
    iconName: 'lie_new',
    iconHeight: 60,
    iconWidth: 100,
    changeUnit: 'bps',
    isCost: true
  },
  CET1: {
    iconName: 'dumbell_new',
    iconHeight: 60,
    iconWidth: 110,
    changeUnit: 'bps',
    isCost: false
  },
  TSR: {
    iconName: 'loan',
    iconHeight: 70,
    iconWidth: 110,
    changeUnit: '%',
    isCost: false
  },
  ROE: {
    iconName: 'roe',
    iconHeight: 70,
    iconWidth: 110,
    changeUnit: '%',
    isCost: false
  },
  Complaints: {
    iconName: 'dislike',
    iconHeight: 70,
    iconWidth: 110,
    changeUnit: '',
    isCost: true
  },
  EmployeeEngagement: {
    iconName: 'smile',
    iconHeight: 70,
    iconWidth: 110,
    changeUnit: '%',
    isCost: false
  },
  RemediationAndFines: {
    iconName: 'penalty',
    iconHeight: 70,
    iconWidth: 110,
    changeUnit: 'm',
    isCost: true
  }
}

const colours = [
  lighten(0.1, theme.colours.orange),
  lighten(0.1, theme.colours.blue),
  lighten(0.1, theme.colours.magenta),
  lighten(0.1, theme.colours.third),
  lighten(0.1, theme.colours.purple),
  lighten(0.1, theme.colours.darkBlue)
]
export default class FinancialSummaryItem extends PureComponent {
  render () {
    const { item, onPressHelpHandler, index } = this.props
    const { iconName, iconWidth, changeUnit, isCost, iconHeight } = configuration[item.type]
    const colour = colours[index % colours.length]
    const { valueChange, valueString } = formatItemValue(item)
    return (
      <Card>
        <CardContent borderColour={colour}>
          <HelpIcon>
            <Touchable onPress={(evt) => onPressHelpHandler(evt, item.helpHeading, item.helpBody)}>
              <Icon name='help' size='xxl' darkgrey />
            </Touchable>
          </HelpIcon>
          <IconContainer>
            <Icon height={iconHeight} width={iconWidth} name={iconName} colour={colour} />
          </IconContainer>
          <TranslatedText size='xl' medium black value={`ourFinancials.summaryMetrics.metrics.${item.type}.heading`} default={item.heading} />
        </CardContent>
        <CardMetrics borderColour={colour}>
          <ValueRow style={{ alignItems: 'flex-end' }}>
            <Text size='huger' medium colour={colour}>{valueString}</Text>
            {valueString !== 'None' && <TranslatedText size='xl' medium colour={colour} overrides={{ marginBottom: 6 }} value={`ourFinancials.summaryMetrics.metrics.${item.type}.unit`} default={changeUnit} />}
          </ValueRow>
          <ValueRow>
            <ValueChangeText size='xl' medium value={valueChange || item.valueChange} isCost={isCost} changeUnit={translate(`ourFinancials.summaryMetrics.metrics.${item.type}.unit`, changeUnit)} />
          </ValueRow>
        </CardMetrics>
      </Card>
    )
  }
}
